module.exports = __webpack_public_path__ + "img/slot-cq9.c7c5dc4a.png";